//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const straps = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 3, 3, 3, 3, 3, 0, 0, 0, 
    0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 0, 0, 
    0, 0, 0, 0, 4, 0, 0, 0, 5, 0, 0, 0, 
    0, 0, 0, 0, 0, 4, 0, 5, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 5, 0, 4, 0, 0, 0, 0, 
    0, 0, 0, 0, 5, 0, 0, 0, 4, 0, 0, 0, 
    0, 0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]
